// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"2b6ee883","342":"4d637aef","453":"d855a71b","734":"62723edc","868":"bed44611"}[chunkId] + ".chunk.js";
};